/** Max health used for bar fill width and barrier positions along the health bar. */
export const BATTLE_HEALTH_MAX_VISUAL = 30;

/** Five barrier markers: destroyed when health ≤ threshold or threshold is in `barriersRemoved`. */
export const BATTLE_HEALTH_BARRIER_THRESHOLDS = [25, 20, 15, 10, 5];

export const BATTLE_HEALTH_BARRIER_COUNT = BATTLE_HEALTH_BARRIER_THRESHOLDS.length;

/** Authoritative count of barriers still up (for HUD tooltips; not delayed sprite display). */
export function countBarriersUp(health, barriersRemoved) {
  const healthNum = Number(health);
  const h = Number.isFinite(healthNum) ? healthNum : 0;
  const removed = Array.isArray(barriersRemoved) ? barriersRemoved : [];
  let count = 0;
  for (const threshold of BATTLE_HEALTH_BARRIER_THRESHOLDS) {
    if (h > threshold && !removed.includes(threshold)) {
      count += 1;
    }
  }
  return count;
}

/** Delay before HUD barrier sprites show dismantled (lets dismantle SFX play before the art updates). */
export const BARRIER_SPRITE_DISMANTLE_DELAY_MS = 1000;
